import { getTotalFeedbackApi } from "@services/MarketWorking/MyDiary/getTotalFeedbackApi";
import {
  GET_FEEDBACK_DETAILS_SUCCESS,
  GET_FEEDBACK_DETAILS_FAIL,
} from "../constants/action-types";
import { setAlert } from "./alert-action";
import { sessionExpireTimeout } from "./utility-actions";

export const getFeedbackDetails = () => async (dispatch) => {
  const response = await getTotalFeedbackApi();
  if (response?.status === 200) {
    dispatch({
      type: GET_FEEDBACK_DETAILS_SUCCESS,
      payload: response?.data,
    });
  } else if (response?.error === "ERR_NETWORK") {
    sessionExpireTimeout(dispatch);
  } else {
    dispatch({
      type: GET_FEEDBACK_DETAILS_FAIL,
    });
    dispatch(setAlert(response?.error, "error"));
  }
};
